/* KUVA product card behaviour. Event-delegated at document level so it works for
   cards rendered now, in a rail, in a grid, or injected later by filtering.
   Load guard: multiple sections each output this script tag; bind only once,
   otherwise one tap on quick-add would add the item once per section. */
(function () {
  if (window.__kuvaCardBound) return;
  window.__kuvaCardBound = true;

  function card(el) { return el.closest('[data-kc-card]'); }

  /* ---------------------------------------------------------------- add to cart */

  /* Ask Shopify to re-render the drawer and the header bubble in the same request.
     The vendor drawer's renderContents() expects exactly these two section ids, so
     handing it the response opens the drawer already showing the new line item -
     no second round trip, and no silent add. The open drawer is also the customer's
     receipt: it names the variant that actually went in, which a tick on a button
     cannot do. */
  function addToCart(id, onSettled) {
    var drawer = document.querySelector('cart-drawer');
    /* On the cart page the page itself is the cart view: reload it so the new
       line item and totals appear in the list, instead of opening the drawer
       over a stale page. Matches /cart and /<locale>/cart. */
    var onCartPage = /\/cart\/?$/.test(window.location.pathname);
    var body = { items: [{ id: id, quantity: 1 }] };
    if (!onCartPage && drawer && typeof drawer.renderContents === 'function') {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        /* /cart/add.js rejections (sold out, stock limits) come back 200-shaped
           as {status, message, description} - a failure, not a success. */
        if (res && res.status && res.description && !res.sections) {
          if (onSettled) onSettled(false);
          return;
        }
        if (onCartPage) { window.location.reload(); return; }
        if (drawer && typeof drawer.renderContents === 'function' && res && res.sections) {
          /* The vendor's renderContents() clears is-empty from .drawer__inner, but the
             class actually sits on <cart-drawer> and the CSS keys off
             cart-drawer:not(.is-empty). Left stale, the drawer opens showing the
             empty-cart message beside the item just added. We know it is not empty. */
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          /* No drawer on this page (or the theme changed): tell the header to refresh
             rather than leaving the count stale. */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
        if (onSettled) onSettled(true);
      })
      .catch(function () { if (onSettled) onSettled(false); });
  }

  function flashTick(btn) {
    if (!btn) return;
    btn.textContent = '✓';
    btn.setAttribute('data-done', '1');
    setTimeout(function () { btn.textContent = '+'; btn.removeAttribute('data-done'); }, 1600);
  }

  /* ------------------------------------------------------------ confirm sheet */

  /* One sheet for the whole page, not one per card. A rail can hold twelve cards;
     twelve hidden dialogs is DOM we would never use, and appending to <body> keeps
     the panel out of the rail's overflow-x clipping. */
  var sheet = null, opener = null, list = [], pick = 0, ctx = null;

  function build() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'kc-sheet';
    sheet.setAttribute('hidden', '');
    sheet.innerHTML =
      '<div class="kc-sheet__scrim" data-kc-close></div>' +
      '<div class="kc-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="kcSheetTitle" tabindex="-1">' +
        '<button type="button" class="kc-sheet__x" data-kc-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="kc-sheet__head">' +
          '<img class="kc-sheet__img" alt="" width="72" height="72">' +
          '<div class="kc-sheet__meta">' +
            '<p class="kc-sheet__title" id="kcSheetTitle"></p>' +
            '<p class="kc-sheet__sel" data-kc-sel></p>' +
            '<p class="kc-sheet__price" data-kc-price2></p>' +
          '</div>' +
        '</div>' +
        '<p class="kc-sheet__lab" data-kc-lab></p>' +
        '<div class="kc-sheet__opts" role="radiogroup" data-kc-opts></div>' +
        '<button type="button" class="kc-sheet__cta" data-kc-confirm></button>' +
      '</div>';
    document.body.appendChild(sheet);
    return sheet;
  }

  function render() {
    var v = list[pick];
    var img = sheet.querySelector('.kc-sheet__img');
    if (v.i) { img.src = v.i; img.hidden = false; } else { img.hidden = true; }
    sheet.querySelector('[data-kc-sel]').textContent = v.c || v.t || '';
    sheet.querySelector('[data-kc-price2]').textContent = v.p || '';
    var cta = sheet.querySelector('[data-kc-confirm]');
    cta.textContent = ctx.addLabel + (v.p ? ' · ' + v.p : '');
    cta.disabled = !v.a;
    if (!v.a) cta.textContent = ctx.soldLabel;
    sheet.querySelectorAll('[data-kc-opt-i]').forEach(function (b, i) {
      b.setAttribute('aria-checked', String(i === pick));
    });
  }

  function open(c, btn) {
    var raw = c.querySelector('script[data-kc-vars]');
    var parsed = null;
    try { parsed = raw ? JSON.parse(raw.textContent) : null; } catch (e) { parsed = null; }
    if (!parsed || parsed.length < 2) return false;   /* nothing to confirm */

    build();
    list = parsed;
    opener = btn;
    var nm = c.querySelector('.kc-nm');
    ctx = {
      addLabel: (btn.getAttribute('aria-label') || 'Add to cart'),
      soldLabel: c.getAttribute('data-kc-sold') || 'Sold out',
      optName: c.getAttribute('data-kc-opt') || 'Colour'
    };

    /* Open on whatever the customer is already looking at, so the sheet confirms
       their choice rather than resetting it. */
    var current = parseInt(c.getAttribute('data-vid'), 10);
    pick = 0;
    for (var i = 0; i < list.length; i++) { if (list[i].id === current) { pick = i; break; } }

    sheet.querySelector('.kc-sheet__title').textContent = nm ? nm.textContent.trim() : '';
    sheet.querySelector('[data-kc-lab]').textContent = ctx.optName;
    if (c.getAttribute('dir')) sheet.setAttribute('dir', c.getAttribute('dir'));

    var opts = sheet.querySelector('[data-kc-opts]');
    opts.innerHTML = '';
    list.forEach(function (v, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kc-sheet__opt';
      b.setAttribute('role', 'radio');
      b.setAttribute('data-kc-opt-i', String(i));
      b.setAttribute('aria-checked', 'false');
      if (!v.a) b.setAttribute('data-sold', '1');
      b.innerHTML =
        '<span class="kc-sheet__chip"' + (v.i ? ' style="background-image:url(' + v.i + ')"' : '') + '></span>' +
        '<span class="kc-sheet__name"></span>' +
        (v.a ? '' : '<span class="kc-sheet__out"></span>');
      b.querySelector('.kc-sheet__name').textContent = v.c || v.t;
      if (!v.a) b.querySelector('.kc-sheet__out').textContent = ctx.soldLabel;
      opts.appendChild(b);
    });

    render();
    sheet.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    /* Force a reflow so the transition has a start value, then flip the state in the
       same tick. requestAnimationFrame reads better, but it does not fire in a
       backgrounded tab: the sheet then mounted with the page dimmed and scrolling
       locked while the panel stayed parked off-screen below the fold - a dark, dead
       screen the customer could not dismiss. Nothing here needs to wait for a frame. */
    void sheet.offsetHeight;
    sheet.setAttribute('data-in', '1');
    sheet.querySelector('.kc-sheet__panel').focus();
    return true;
  }

  function close() {
    if (!sheet || sheet.hasAttribute('hidden')) return;
    sheet.removeAttribute('data-in');
    sheet.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (opener) { opener.focus(); opener = null; }
  }

  /* ------------------------------------------------------------------- events */

  document.addEventListener('click', function (e) {
    /* swatch: preview the colour on the card itself */
    var sw = e.target.closest('[data-kc-s]');
    if (sw) {
      var c = card(sw); if (!c) return;
      c.querySelectorAll('[data-kc-s]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      sw.setAttribute('aria-pressed', 'true');
      var img = c.querySelector('[data-kc-img]');
      var src = sw.getAttribute('data-img');
      if (src && img) { img.src = src; img.setAttribute('data-base', src); img.removeAttribute('data-hover'); }
      var col = c.querySelector('[data-kc-col]');
      if (col) col.textContent = sw.getAttribute('data-name') || '';
      var pr = c.querySelector('[data-kc-price]');
      if (pr) pr.textContent = sw.getAttribute('data-price') || '';
      c.setAttribute('data-vid', sw.getAttribute('data-vid'));
      return;
    }

    if (e.target.closest('[data-kc-close]')) { close(); return; }

    var opt = e.target.closest('[data-kc-opt-i]');
    if (opt) {
      if (opt.getAttribute('data-sold') === '1') return;
      pick = parseInt(opt.getAttribute('data-kc-opt-i'), 10);
      render();
      return;
    }

    var confirm = e.target.closest('[data-kc-confirm]');
    if (confirm) {
      var v = list[pick];
      if (!v || !v.a) return;
      confirm.disabled = true;
      var btn = opener;
      addToCart(v.id, function (ok) {
        confirm.disabled = false;
        close();
        if (ok) flashTick(btn);
      });
      return;
    }

    var add = e.target.closest('[data-kc-add]');
    if (add) {
      e.preventDefault();
      var c2 = card(add); if (!c2) return;
      /* More than one variant: confirm which one before it goes in. A tick on a
         circle tells the customer something was added, not what. */
      if (open(c2, add)) return;
      var id = parseInt(c2.getAttribute('data-vid'), 10);
      if (!id) return;
      add.disabled = true;
      addToCart(id, function (ok) {
        add.disabled = false;
        if (ok) flashTick(add);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!sheet || sheet.hasAttribute('hidden')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    /* Keep Tab inside the dialog: an aria-modal panel the keyboard can walk out of
       leaves the customer typing into a page they cannot see. */
    var f = sheet.querySelectorAll('button:not([disabled])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Desktop hover: show the second photo, but only on devices that can really hover.

     Touch screens must not run this. iOS Safari fires a synthetic mouseover when a card
     is tapped, so the photo was swapped to the hover image and the page navigated away in
     the same instant. The browser cancelled that half-loaded request and froze the page
     with a broken image, and pressing Back restored it as the grey "?" with the product
     name. The hover photo is also preloaded and only shown once it has arrived, so a card
     never sits on a half-loaded src. Delegated, so it also covers new cards. */
  var canHover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  function hoverOk() { return !canHover || canHover.matches; }

  document.addEventListener('mouseover', function (e) {
    if (!hoverOk()) return;
    var m = e.target.closest('[data-kc-card] [data-kc-img]');
    if (!m) return;
    var h = m.getAttribute('data-hover');
    if (!h || m.getAttribute('src') === h) return;
    if (!m.getAttribute('data-base')) m.setAttribute('data-base', m.getAttribute('src'));
    var pre = new Image();
    pre.onload = function () { if (m.matches(':hover')) m.setAttribute('src', h); };
    pre.src = h;
  });
  document.addEventListener('mouseout', function (e) {
    var m = e.target.closest('[data-kc-card] [data-kc-img]');
    if (!m) return;
    var b = m.getAttribute('data-base');
    if (b && m.getAttribute('data-hover')) m.setAttribute('src', b);
  });

  /* Safety net for Back / forward. Before the page is frozen, put any card photo that is
     sitting on its hover image back to the base photo. On return, repair any photo the
     browser gave up on (complete, but zero width) by asking for it again. */
  window.addEventListener('pagehide', function () {
    document.querySelectorAll('[data-kc-card] [data-kc-img][data-base][data-hover]').forEach(function (m) {
      var b = m.getAttribute('data-base');
      if (b && m.getAttribute('src') !== b) m.setAttribute('src', b);
    });
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-kc-card] img').forEach(function (im) {
      if (!im.complete || im.naturalWidth > 0) return;
      var s = im.getAttribute('data-base') || im.getAttribute('src');
      if (!s) return;
      im.removeAttribute('src');
      im.setAttribute('src', s);
    });
  });
})();
